var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgErrorExclamation = function SvgErrorExclamation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    y: 0.336,
    fill: "#B87E7E",
    rx: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m10.713 12.733.518-6.154s0-1.243-1.232-1.243c-1.233 0-1.233 1.243-1.233 1.243l.518 6.154s.098.577.714.577c.617 0 .715-.577.715-.577M10.781 14.553a.783.783 0 1 1-1.565 0 .783.783 0 0 1 1.565 0"
  })));
};
export default SvgErrorExclamation;